import React, {Component} from 'react'
import {Spin} from "antd";
import ItemsTableHead from "./ItemsTableHead"
import ItemsTableBody from "./ItemsTableBody"

class ItemsTable extends Component {

    render() {
        const {listJobs, loading} = this.props

        return (
            <div className="JobItemTable">
                <Spin spinning={loading} tip={'Đang lấy dữ liệu từ server...'}>
                    <table className='table'>
                        <ItemsTableHead/>
                        <ItemsTableBody listJobs={listJobs}/>
                    </table>
                </Spin>
            </div>
        )
    }

}

export default ItemsTable